import sensorsMutations from "./mutations";
import sensorsActions from "./actions";

export default {
  namespaced: true,
  state: {
    sensors: [],
    sensor: null,
    userSensors: [],
    temperatureChart: [],
    humidityChart: [],
    pressureChart: [],
    aqiChart: [],
    pm1Chart: [],
    pm2_5Chart: [],
    pm4Chart: [],
    pm10Chart: [],
    covChart: [],
    co2Chart: [],
  },
  getters: {
    getSensors: (state) => state.sensors,
    getSensor: (state) => state.sensor,
    getUserSensors: (state) => state.userSensors,
    getTemperature: (state) => state.temperatureChart,
    getHumidity: (state) => state.humidityChart,
    getPressure: (state) => state.pressureChart,
    getAqi: (state) => state.aqiChart,
    getPM1: (state) => state.pm1Chart,
    getPM2_5: (state) => state.pm2_5Chart,
    getPM4: (state) => state.pm4Chart,
    getPM10: (state) => state.pm10Chart,
    getCov: (state) => state.covChart,
    getCO2: (state) => state.co2Chart,
  },
  mutations: sensorsMutations,
  actions: sensorsActions,
};
